/**
 * Russian translations
 */
export default {
  "Sign in": "Войти",
  "Your session has ended. Please sign in again.": "Сессия завершена. Войдите снова.",
  "Sign-in was denied.": "Вход отклонён.",
  "Sign-in expired. Please try again.": "Время входа истекло. Войдите снова.",
  "Sign-in failed. Please try later.": "Не удалось войти. Попробуйте позже.",
  "Unknown user": "Пользователь неизвестен",
  "Unknown version": "Версия неизвестна",
  "No sections are permitted.": "Ни один раздел не разрешён.",
  "This section does not exist.": "Раздел по этому адресу не найден.",
  "Go to the initial section": "Перейти в начальный раздел",

  "The installation license is invalid. Requests cannot be performed.": "Лицензия установки недействительна, модуль управления обращений не выполняет.",
  'Session ended. Please log in again.': 'Сессия прекращена. Войдите заново.',
  'Log in again': 'Войти заново',
  "Change password": "Изменить пароль",
  "Current password": "Текущий пароль",
  "New password": "Новый пароль",
  "Password changed. Please log in again.": "Пароль изменён. Войдите заново.",
  "The submitted values were not accepted.": "Переданные значения не приняты.",
  "Authentication was not established. The operation was not performed.": "Подлинность обращения не установлена, операция не выполнена.",
  "Authentication was not established.": "Подлинность обращения не установлена.",
  "This operation is not permitted.": "Выполнить операцию не разрешено.",
  "The requested object does not exist.": "Запрошенный объект не существует.",
  "The operation conflicts with the current state.": "Операция несовместима с текущим состоянием.",
  "The server encountered an internal error.": "Сбой на стороне модуля управления.",
  "The server rejected the request without a reason.": "Модуль управления обращение не выполнил, причины он не назвал.",
  "No response was received from the server.": "Ответ от модуля управления не получен.",
  'Unable to save event listener. Check the connection and retry.': 'Не удалось сохранить обработчик событий. Проверьте соединение и повторите попытку.',
  'Unable to save schedule. Check the connection and retry.': 'Не удалось сохранить расписание. Проверьте соединение и повторите попытку.',
  'Unable to load job parameters (HTTP {status}). Reopen the form to retry.': 'Не удалось загрузить параметры графа (HTTP {status}). Откройте форму заново для повторной попытки.',
  'Unable to load job parameters. Check the connection and reopen the form to retry.': 'Не удалось загрузить параметры графа. Проверьте соединение и откройте форму заново для повторной попытки.',
  'Date and time format': 'ДД.ММ.ГГГГ ЧЧ:ММ:СС',
  'Unknown date and time': 'неизвестно',
  'Enter date and time in the required format': 'Введите существующую дату и время в формате ДД.ММ.ГГГГ ЧЧ:ММ:СС',
  // Auth
  Username: 'Имя пользователя',
  Password: 'Пароль',
  Login: 'Войти',
  Logout: 'Выход',
  'Show password': 'Показать пароль',
  'Please, fill in this field': 'Пожалуйста, заполните это поле',

  // Menu
  Resources: 'Ресурсы',
  'Execution History': 'История выполнения',
  Projects: 'Проекты',
  Schedules: 'Расписания',
  'Events Listeners': 'Слушатели событий',
  'Data Services': 'Сервисы данных',
  Users: 'Пользователи',
  Roles: 'Роли',

  // Resources
  'Resources utilization': 'Использование ресурсов',
  Worker: 'Воркер',
  System: 'Система',
  Performance: 'Производительность',
  'Running jobs': 'Запущенные задачи',
  CPU: 'ЦП',
  RAM: 'ОЗУ',
  Disk: 'Диск',
  Used: 'Использовано',
  Free: 'Свободно',
  of: 'из',
  gb: 'ГБ',
  Uptime: 'Время работы',
  Name: 'Имя',
  IP: 'IP',
  'Current time': 'Текущее время',
  'UTC time': 'Время UTC',
  Version: 'Версия',
  Job: 'Задача',

  // Common
  Loading: 'Загрузка',
  'Onebridge designer': 'Дизайнер Onebridge',
  'Onebridge documentation': 'Документация Onebridge',

  // Errors
  'Invalid credentials': 'Неверные учетные данные',
  'Authentication failed': 'Ошибка авторизации',
  'Network error occurred': 'Произошла сетевая ошибка',
  'Username cannot be empty': 'Имя пользователя не может быть пустым',
  'Password cannot be empty': 'Пароль не может быть пустым',

  // Schedules
  'New schedule': 'Новое расписание',
  'Create schedule': 'Создать расписание',
  'Change schedule': 'Изменить расписание {name}',
  'Delete schedule': 'Удалить расписание',
  'Edit schedule': 'Редактировать расписание',
  'Run linked graph': 'Запустить связанный граф',
  'Name Schedule': 'Название расписания',
  'The name cannot be empty': 'Название не может быть пустым',
  'This name already exists': 'Это название уже существует',
  Periodicity: 'Периодичность',
  Once: 'Однократно',
  Interval: 'Интервал',
  Timetable: 'Расписание',
  'Start time': 'Время запуска',
  'Run every': 'Запускать каждые',
  'Cron expression': 'Cron выражение',
  'Invalid cron expression': 'Неверное cron выражение',
  'Active from': 'Активно с',
  'Active to': 'Активно до',
  'Job file': 'Файл задачи',
  'Please select a file': 'Пожалуйста, выберите файл',
  Project: 'Проект',
  'Select project': 'Выберите проект',
  'Select job file': 'Выберите файл задачи',
  Params: 'Параметры',
  required: 'обязательно',
  Create: 'Создать',
  Save: 'Сохранить',
  Close: 'Закрыть',
  Delete: 'Удалить',
  Cancel: 'Отмена',
  sec: 'сек',
  min: 'мин',
  hr: 'ч',
  ID: 'ID',
  Enabled: 'Включено',
  Schedule: 'Расписание',
  'Last run': 'Последний запуск',
  'The status of the last run': 'Статус последнего запуска',
  'Next run': 'Следующий запуск',
  Search: 'Поиск',
  Overview: 'Обзор',
  Frequency: 'Частота',
  'Last run number': 'Номер последнего запуска',
  Created: 'Создано',
  'Created by': 'Создано пользователем',
  Modified: 'Изменено',
  'Modified by': 'Изменено пользователем',
  'Run graph': 'Файл графа',
  'Input parameters': 'Входные параметры',
  Showing: 'Показано',
  Previous: 'Предыдущая',
  Next: 'Следующая',
  'per page': 'на странице',
  pages: 'страниц',
  rows: 'строк',
  Succeeded: 'Выполнено',
  Failed: 'Не выполнено',
  Aborted: 'Aborted',
  InProgress: 'В процессе',
  Waiting: 'Ожидание',
  Unknown: 'Unknown',
  'someHasBeenDelete.schedule': 'Вы уверены, что хотите удалить расписание "{name}"?',

  // Event Listeners
  'New listener': 'Новый слушатель',
  Listener: 'Слушатель',
  'Create listener': 'Создать слушателя',
  'Change listener': 'Изменить слушателя {name}',
  'Delete event listener': 'Удалить слушателя событий',
  'Edit event listener': 'Редактировать слушателя событий',
  'Name listener': 'Название слушателя',
  Event: 'Событие',
  'File event': 'Событие файла',
  'Job finished event': 'Событие завершения задачи',
  'File system': 'Файловая система',
  Path: 'Путь',
  Check: 'Проверка',
  Action: 'Действие',
  added: 'добавлен',
  removed: 'удален',
  'Start job': 'Запустить задачу',
  'Run command': 'Выполнить команду',
  Started: 'Запущено',
  Program: 'Программа',
  Arguments: 'Аргументы',
  'comma separated': 'через запятую',
  'Interval must be greater than 0': 'Интервал должен быть больше 0',
  'This parameter is required': 'Этот параметр обязателен',
  'someHasBeenDelete.event': 'Вы уверены, что хотите удалить слушателя событий "{name}"?',
  'events.file': 'Событие файла',
  'events.job': 'Событие завершения задачи',
  'events.Finished': 'Завершенная задача',
  'events.Status': 'Статус',
  'events.Succeeded': 'Успешно',
  'events.Failed': 'Ошибка',
  'events.Aborted': 'Прервано',
  'events.Any': 'Любой',

  // Users
  'Add new user': 'Добавить нового пользователя',
  'Update user': 'Редактировать пользователя',
  'User created': 'Пользователь создан',
  'Temporary password': 'Временный пароль',
  Copy: 'Копировать',
  Active: 'Активный',
  'Full name': 'Полное имя',
  'Last login': 'Последний вход',
  Email: 'Email',
  Status: 'Статус',
  'Edit user info': 'Редактировать пользователя',
  'Reset the password': 'Сбросить пароль',
  'Аuthentication method': 'Метод аутентификации',
  'Last login date': 'Дата последнего входа',
  'Last login status': 'Статус последнего входа',
  active: 'Активный',
  inactive: 'Неактивный',
  blocked: 'Заблокирован',
  'The login cannot be empty': 'Логин не может быть пустым',
  'The first name cannot be empty': 'Имя не может быть пустым',
  'The email cannot be empty': 'Email не может быть пустым',
  'All roles': 'Все роли',
  'Assigned roles': 'Выданные роли',
  Privileges: 'Привилегии',

  // Data Services
  'New data service': 'Новый сервис данных',
  'Create data service': 'Создать сервис данных',
  'Change data service': 'Изменить сервис данных {name}',
  'Delete data service': 'Удалить сервис данных',
  'Edit data service': 'Редактировать сервис данных',
  'Data service': 'Сервис данных',
  'Name data service': 'Название сервиса данных',
  Method: 'Метод',
  Calls: 'Вызовы',
  Description: 'Описание',
  Parameters: 'Параметры',
  'Job parameter': 'Параметр задачи',
  'URL name': 'Имя URL',
  Default: 'По умолчанию',
  Required: 'Обязательный',
  Disabled: 'Отключено',
  'someHasBeenDelete.dataService': 'Вы уверены, что хотите удалить сервис данных "{name}"?',

  // Projects
  'Create new project': 'Создать новый проект',
  'Change project': 'Выберите проект или файл',
  'Job Inspector': 'Граф',
  'Content': 'Содержимое',
  'Content file': 'Содержимое файла',
  Type: 'Тип',
  Size: 'Размер',
  project: 'проект',
  directory: 'директория',
  file: 'файл',
  'Edit file': 'Редактировать файл',
  'Rename project': 'Переименовать проект',
  'Rename directory': 'Переименовать директорию',
  'Rename file': 'Переименовать файл',
  'Create directory': 'Создать директорию',
  'Create file': 'Создать файл',
  'Upload files': 'Загрузить файлы',
  'Download as an archive': 'Скачать как архив',
  'Download file': 'Скачать файл',
  'Create schedule in projects': 'Создать расписание',
  'Delete project': 'Удалить проект',
  'Delete directory': 'Удалить директорию',
  'Delete file': 'Удалить файл',
  'New name': 'Новое имя',
  Template: 'Шаблон',
  in: 'в',
  'project name': 'Название проекта',
  'directory name': 'Название директории',
  'file name': 'Название файла',
  'Create project header modal': 'Создать проект',
  'Create directory header modal': 'Создать директорию',
  'Create file header modal': 'Создать файл',
  'The file size is too large to display its content': 'Файл слишком большой для отображения',
  'Oops, something wrong with the file': 'Ой, что-то не так с файлом',
  'runModalHeader': 'Запустить',
  'Run with the following input parameters. Other parameters have default values': 'Запустить со следующими входными параметрами. Остальные параметры имеют значения по умолчанию',
  'input parameters': 'Входные параметры',
  'No parameters required': 'Параметры не требуются',
  'Loading...': 'Загрузка...',
  'someHasBeenDelete.project': 'Вы уверены, что хотите удалить проект "{name}"?',
  'someHasBeenDelete.directory': 'Вы уверены, что хотите удалить директорию "{name}"?',
  'someHasBeenDelete.file': 'Вы уверены, что хотите удалить файл "{name}"?',

  // Execution History
  Filter: 'Фильтровать',
  Reset: 'Сбросить',
  'Date from': 'Дата с',
  'Date to': 'По',
  'Run ID': '№',
  'Run number': '№',
  'Job name': 'Задание',
  User: 'Пользователь',
  Submitted: 'Запущено',
  Run: 'Запуск',
  Rerun: 'Перезапуск',
  Stop: 'Остановить',
  'Download log': 'Скачать лог',
  Tracking: 'Мониторинг',
  'Log File': 'Журнал',
  Duration: 'Длительность',
  'Launch type': 'Тип запуска',
  Finished: 'Завершено',
  Phase: 'Фаза',
  COMPONENT: 'ШАГ',
  STATUS: 'СТАТУС',
  DURATION: 'ДЛИТЕЛЬНОСТЬ',
  PORT: 'ПОРТ',
  RECORDS: 'ЗАПИСЕЙ',
  'RECS/S': 'ЗАПИСЕЙ/СЕК',
  'RECS/S MAX': 'ЗАПИСЕЙ/СЕК МАКС',
  'RECS/S AVG': 'ЗАПИСЕЙ/СЕК СР',
  INPUT: 'ВХОД',
  OUTPUT: 'ВЫХОД',
  'No data': 'Нет данных',
  'All statuses': 'Не выбрано',

  // Roles
  'Add new role': 'Добавить новую роль',
  'Update role': 'Редактировать роль',
  'Delete role': 'Удалить роль',
  'Edit role': 'Редактировать роль',
  'Failed to create role': 'Не удалось создать роль',
  'Failed to update role': 'Не удалось обновить роль',
  'someHasBeenDelete.role': 'Вы уверены, что хотите удалить роль "{name}"?',
}
